/* eslint-disable no-constant-condition, consistent-return */

import { put, fork, takeEvery, call, all } from 'redux-saga/effects'

import {
  loadLanguageSuccess,
  LOAD_LANGUAGE,
  detectAdblockerSuccess,
} from '../actions/global'
import { checkGTMStatus } from '../../utils/api'
import { setLanguageCode } from '../../utils/translation'
import { getLocations } from '../../utils/locations'

export default function* baseDataSaga() {
  yield takeEvery(LOAD_LANGUAGE.action, () => loadLanguage())
  yield fork(preloadLocations)
  yield fork(detectAdblock)
}

function* loadLanguage() {
  yield setLanguageCode()
  yield put(loadLanguageSuccess())
}

function* preloadLocations() {
  yield getLocations(true)
  yield getLocations(false)
}

function* detectAdblock() {
  try {
    const [...responses] = yield all([call(checkGTMStatus)])
    yield put(detectAdblockerSuccess(!responses[0]))
  } catch (e) {
    console.error(e)
    yield put(detectAdblockerSuccess(e && !e.response))
  }
}
